var map = {
	"./Abduction.svg": "dd50",
	"./Arrest.svg": "9c88",
	"./Economic,Social & Cultural Rights.svg": "3db5",
	"./Icon_Closed_case.svg": "432c",
	"./Icon_Compromise.svg": "ee0c",
	"./Icon_Incomplete.svg": "44db",
	"./Icon_Investigation.svg": "7035",
	"./Icon_Legal_Proceeds.svg": "8ee1",
	"./Icon_No_legal_proceedsv.svg": "713e",
	"./Icon__Abduction.svg": "d3d2",
	"./Icon__Beating.svg": "05b7",
	"./Icon__Discrimination.svg": "c76c",
	"./Icon__No legal proceedsv.svg": "5a63",
	"./Icon__Province_1.svg": "7917",
	"./Icon__Province_2.svg": "c86f",
	"./Icon__Torture.svg": "f9c1",
	"./Icon__province_3.svg": "6e47",
	"./Icon__province_4.svg": "5e5b",
	"./Icon__province_5.svg": "b396",
	"./Icon__province_6.svg": "8899",
	"./Icon__province_7.svg": "b24d",
	"./Icon__women_right.svg": "3d38",
	"./Killing.svg": "e472",
	"./Threats.svg": "340a",
	"./Women Rights.svg": "737e",
	"./child Rights.svg": "6f23"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";